var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"account-view"}},[(_vm.$route.hash !== '#wishlist')?_c('bnft-account-nft'):_vm._e(),(_vm.$route.hash === '#wishlist')?_c('bnft-account-wish-list'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }